import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface PremiumLimitBannerProps {
  title: string;
  description: string;
  className?: string;
}

const PremiumLimitBanner = ({ title, description, className = '' }: PremiumLimitBannerProps) => {
  const navigate = useNavigate();

  return (
    <Alert className={`border-nautic-gold bg-nautic-gold/10 ${className}`}>
      <Crown className="h-4 w-4 text-nautic-gold" />
      <AlertTitle className="text-nautic-gold">{title}</AlertTitle>
      <AlertDescription className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <span className="flex-1">{description}</span>
        <Button 
          size="sm"
          onClick={() => navigate('/account')}
          className="bg-nautic-gold text-nautic hover:bg-nautic-lightgold whitespace-nowrap"
        >
          <Crown className="h-3 w-3 mr-1" />
          Passer Premium
        </Button>
      </AlertDescription>
    </Alert>
  );
};

export default PremiumLimitBanner;
